import { render } from "./SitesList.vue?vue&type=template&id=480e6c9a&ts=true"
import script from "./SitesList.vue?vue&type=script&lang=ts"
export * from "./SitesList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__